import React from 'react';
import Invoice from './Invoice';
 
export default (props) => <Invoice {...props}/>;
